"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonValue = void 0;
const zod_1 = require("zod");
exports.JsonValue = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.lazy(() => zod_1.z.array(exports.JsonValue)),
    zod_1.z.lazy(() => zod_1.z.record(exports.JsonValue)),
]);
exports.default = exports.JsonValue;
//# sourceMappingURL=JsonValue.js.map